import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MobileLayout from '../../components/mobile/MobileLayout';
import { useContactInfo, textLines } from '../../lib/publicContent';
import { ed, usePageMeta } from '../../lib/editTexts';

export default function MobileSupport() {
  const { t } = useTranslation();
  const { location, email } = useContactInfo();
  usePageMeta('support');
  // Impressum: Anschrift aus AgoraHub-Kontakt, ausser legal.imprint.address ist gepflegt; Register/Verantwortlich nur wenn gepflegt.
  const address = textLines(t('legal.imprint.address'));
  const register = t('legal.imprint.register');
  const responsible = textLines(t('legal.imprint.responsible'));

  const cards = [
    { n: '01', id: 'contact', href: 'mailto:marcus.dolak@agorahub.de?subject=KAC%20Berlin%20Support' },
    { n: '02', id: 'privacy', to: '/privacy' },
    { n: '03', id: 'help', href: `mailto:${email}?subject=${encodeURIComponent(t('support.help.mail_subject'))}` },
  ];

  return (
    <MobileLayout>
      <section className="m-hero">
        <span className="m-kicker" {...ed('support.eyebrow')}>{t('support.eyebrow')}</span>
        <h1 {...ed('support.title')}>{t('support.title')}</h1>
        <p {...ed('support.description')}>{t('support.description')}</p>
      </section>

      <section style={{ padding: '0 22px', display: 'flex', flexDirection: 'column', gap: 14 }}>
        {cards.map(c => (
          <div key={c.n} className="m-card" style={{ padding: '24px 22px' }}>
            <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.05em', color: '#C0291F', marginBottom: 10 }}>
              {c.n} — <span {...ed(`support.${c.id}.tag`)}>{t(`support.${c.id}.tag`)}</span>
            </div>
            <h3 {...ed(`support.${c.id}.title`)} style={{ margin: '0 0 10px', fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 20 }}>{t(`support.${c.id}.title`)}</h3>
            <p {...ed(`support.${c.id}.description`)} style={{ margin: '0 0 16px', fontSize: 14, lineHeight: 1.6, color: '#5e554b' }}>{t(`support.${c.id}.description`)}</p>
            {c.to ? (
              <Link to={c.to} className="m-link"><span {...ed(`support.${c.id}.button`)}>{t(`support.${c.id}.button`)}</span> →</Link>
            ) : (
              <a href={c.href} target={c.href?.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer" className="m-link">
                <span {...ed(`support.${c.id}.button`)}>{t(`support.${c.id}.button`)}</span> →
              </a>
            )}
          </div>
        ))}

        {/* Impressum / Organisation — Adresse live aus contact-info */}
        <div className="m-red m-red-radius" style={{ padding: '26px 22px' }}>
          <div {...ed('support.organization.title')} style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.05em', color: 'rgba(255,255,255,0.78)', marginBottom: 12 }}>{t('support.organization.title')}</div>
          <h3 {...ed('support.organization.name')} style={{ margin: '0 0 14px', fontFamily: "'Bricolage Grotesque',sans-serif", fontWeight: 700, fontSize: 19, lineHeight: 1.2 }}>
            {t('support.organization.name')}
          </h3>
          <div style={{ fontSize: 14, lineHeight: 1.75, color: 'rgba(255,255,255,0.92)' }}>
            {address.length > 0
              ? <div {...ed('legal.imprint.address', 'lines')}>{address.map((line, i) => <div key={i}>{line}</div>)}</div>
              : (
                <div data-edit-central="contact_info">
                  {location && <>{location.addressLine1}<br />{location.addressLine2}<br /></>}
                  <span {...ed('support.organization.country')}>{t('support.organization.country')}</span>
                </div>
              )}
            <br />
            <span {...ed('support.organization.email_label')} style={{ color: 'rgba(255,255,255,0.7)' }}>{t('support.organization.email_label')}</span> <span data-edit-central="contact_info">{email}</span><br />
            <span {...ed('support.organization.representative_label')} style={{ color: 'rgba(255,255,255,0.7)' }}>{t('support.organization.representative_label')}</span> <span {...ed('support.organization.representative_name')}>{t('support.organization.representative_name')}</span><br />
            {register && <div {...ed('legal.imprint.register')}>{register}</div>}
            {responsible.length > 0 && (
              <>
                <br />
                <span {...ed('support.organization.responsible_label')} style={{ color: 'rgba(255,255,255,0.7)' }}>{t('support.organization.responsible_label')}</span><br />
                <div {...ed('legal.imprint.responsible', 'lines')}>{responsible.map((line, i) => <div key={i}>{line}</div>)}</div>
              </>
            )}
          </div>
        </div>
      </section>
    </MobileLayout>
  );
}
